import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientDataForAppoinment } from '../service/make-appoinment.model';
import { MakeAppointmentService } from '../service/make-appointment.service';
import { SharedService } from 'src/app/services/shared.service';
import { ToastType } from 'src/app/enums/enums';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-neuro-appointment',
  templateUrl: './neuro-appointment.component.html',
  styleUrls: ['./neuro-appointment.component.scss']
})
export class NeuroAppointmentComponent {
  NeuroAppoinmentForm: FormGroup;
  @Input() patientData: PatientDataForAppoinment = {
    id: 0,
    name: '',
    caseName: '',
    da: '',
    de: '',
    clinicId: 0,
    isDischarged: false
  };
  isData = false;
  activeModal = inject(NgbActiveModal);
  currentDate = new Date();
  constructor(private makeAppointmentService: MakeAppointmentService, private sharedService: SharedService, private toast: ToastService) {
    this.NeuroAppoinmentForm = new FormGroup({
      nextNeuro: new FormControl(null),
      neuroPRN: new FormControl(false),
      neuroFU1: new FormControl(null),
      neuroFU2: new FormControl(null),
      neuroFU3: new FormControl(null),
      neuroFU4: new FormControl(null),
      neuroFU5: new FormControl(null),
      neuroFU6: new FormControl(null),
      uemgDate: new FormControl(null),
      noUpperEMG: new FormControl(false),
      lemgDate: new FormControl(null),
      noLowerEMG: new FormControl(false)
    });
    this.currentDate.setHours(0, 0, 0, 0);
  }

  ngOnInit() {
    const fieldsToWatch = ['nextNeuro', 'neuroPRN', 'uemgDate', 'noUpperEMG', 'lemgDate', 'noLowerEMG'];
    fieldsToWatch.forEach((fieldName) => {
      this.NeuroAppoinmentForm.get(fieldName)?.valueChanges.subscribe((value) => {
        switch (fieldName) {
          case 'nextNeuro':
          case 'neuroPRN':
            this.checkDate('nextNeuroDiv', 'neuroPRN', 'nextNeuro');
            break;
          case 'uemgDate':
          case 'noUpperEMG':
            this.checkDate('uemgDateDiv', 'noUpperEMG', 'uemgDate');
            break;
          case 'lemgDate':
          case 'noLowerEMG':
            this.checkDate('lemgDateDiv', 'noLowerEMG', 'lemgDate');
            break;
        }
      });
    });
    this.getNeuroAppoinment(this.patientData.id);
  }

  getNeuroAppoinment(id: number) {
    this.makeAppointmentService.getNeuroAppoinment(id).subscribe({
      next: (res) => {
        this.isData = true;
        const data = this.sharedService.changeDateToString(res.result);
        const { id, patientId, clinicId, neuro, ...rest } = data;
        this.NeuroAppoinmentForm.setValue(rest);
      },
      error: (error) => {
        console.error(error, 'error');
      },
      complete: () => {}
    });
  }

  makeNeuroAppoinment() {
    let data = this.NeuroAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;
    this.makeAppointmentService.makeNeuroAAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'Neuro Appointment created successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  updateNeuroAppointment() {
    let data = this.NeuroAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;

    const dateFields = ['nextNeuro', 'neuroFU1', 'neuroFU2', 'neuroFU3', 'neuroFU4', 'neuroFU5', 'uemgDate', 'lemgDate'];
    dateFields.forEach((field) => {
      if (data[field] === '') {
        data[field] = null;
      }
    });

    this.makeAppointmentService.updateNeuroAAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'Neuro Appointment updated successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  checkDate(div: string, checkbox: string, mainField: string) {
    const myDiv = document.getElementById(div);
    const checkboxValue = this.NeuroAppoinmentForm.get(checkbox)?.value;
    const mainFieldValue = this.NeuroAppoinmentForm.get(mainField)?.value;
    if (!checkboxValue && this.isData && mainFieldValue) {
      const date2 = new Date(mainFieldValue);
      if (this.currentDate > date2) {
        myDiv?.classList.add('highlight-red');
      } else {
        myDiv?.classList.remove('highlight-red');
      }
    } else {
      myDiv?.classList.remove('highlight-red');
    }
  }
}
